import React from 'react';
import { NCZIMessageResult } from '../../../Interfaces/ncziTypes';
// @ts-ignore
import styles from './EHRResult.module.scss';

interface Props {
	ehrResult: NCZIMessageResult | undefined;
}

const EHRResult: React.FC<Props> = props => {
	const { ehrResult } = props;

	if (!ehrResult) {
		return <></>;
	}

	const displayableCode = ehrResult?.code !== '0' && ehrResult?.code !== '';
	const warnings = ehrResult?.details?.warnings || [];
	const exceptionMessage = ehrResult?.details?.exception?.message;

	if (!(displayableCode || warnings.length > 0 || exceptionMessage)) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.warning}>
				{displayableCode && <div>{ehrResult.message}</div>}
				{warnings.map((warning, key) => (
					<div key={key}>{warning}</div>
				))}
				{exceptionMessage && <div>{exceptionMessage}</div>}
			</div>
		</div>
	);
};

export default EHRResult;
